import { JetView } from "webix-jet";

import TopBar from "./topbar";
import SideBar from "./sidebar";
import SideMenu from "./compact/sidemenu";
import "../helpers/responsive";

export default class TopView extends JetView {
	config() {
		const fCompact = this.getParam("forceCompact");
		const isForced = typeof fCompact !== "undefined";
		if (isForced) this.setParam("compact", fCompact);
		this.Compact = this.getParam("compact");

		let cols = this.Compact
			? [{ $subview: true }]
			: [SideBar, { $subview: true }];
		return {
			borderless: true,
			view: isForced ? "layout" : "r-layout",
			rows: [
				TopBar,
				{
					localId: "main",
					borderless: true,
					cols,
				},
			],
		};
	}

	init() {
		// responsive UI
		const root = this.getRoot();
		if (root.sizeTrigger)
			root.sizeTrigger(
				this.app.config.compactWidth,
				mode => this.SetCompactMode(mode),
				!!this.Compact
			);

		this.on(this.app, "menu:click", () => this.ShowSideMenu());
		this.on(this.app, "details:item-click", (collection, id) =>
			this.ShowDetails(collection, id)
		);

		this.on(this.app, "details.back:click", (coll, id) =>
			this.ShowList(coll, id)
		);
	}
	urlChange() {
		this.app.callEvent("top:navigation");
	}

	SetCompactMode(mode) {
		// delay is necessary to prevent the refresh call
		// while this view is still in rendering process
		webix.delay(() => {
			this.setParam("compact", mode);
			this.refresh();
		});
	}

	ShowSideMenu() {
		if (!this.SideMenu || !this.SideMenu.getRoot())
			this.SideMenu = this.ui(SideMenu);

		const box = this.$$("main").$view.getBoundingClientRect();
		this.SideMenu.Show(box);
	}

	ShowDetails(collection, id) {
		const details =
			this.Compact && collection !== "rules" ? "editor" : "details";
		if (this.Compact) this.show(`./${collection}.${details}?id=${id}`);
		else this.show(`./${collection}?id=${id}/${collection}.${details}`);
	}
	ShowList(collection, id) {
		if (this.Compact) {
			this.show(`./${collection}`);
		} else {
			this.show(`./${collection}?id=${id}/${collection}.details`);
		}
	}
}
